import { useGetSocialTopBets } from 'src/store/social'
import type { SocialBet } from 'src/types/domain/SocialBet'
import type { Marble } from 'src/types/domain/Marble';
import { SOCIAL_CONFIG } from "src/config";
import { BetListItem } from './BetListItem'

type Props = Readonly<{
  marbles: Marble[]
}>

export function BetListItems({ marbles }: Props) {
  const bets = useGetSocialTopBets()

  return (
    <div className="players-bets">
      {bets
        .sort((a, b) => b.betAmount - a.betAmount)
        .slice(0, SOCIAL_CONFIG.TOP_BETS_LIMITER)
        .map((bet: SocialBet) => (
          <BetListItem
            bet={bet}
            key={bet.id}
            marbles={marbles}
          />
        ))}
    </div>
  )
}
